import {IApiEndpoint, IPagination} from "@localization/siteMap/siteMapInterfaces.ts";
import {IEmpresa} from "@models/empresa/IEmpresa.ts";
import {IGetEmpresasFilter} from "@components/empresas/endpoints/filters/IGetEmpresaFilter.ts";
import {IMapDefinition} from "@localization/siteMap/breadcrumbs/_Sitemap.ts";
import {ICreateEmpresaDto} from "@models/empresa/dto/ICreateEmpresaDto.ts";

export const _empresa_endpoints = {
    ['get-empresas']: (data: { filters: IGetEmpresasFilter, pagination: IPagination }) => {
        return {
            url: '/api/Empresas/GetEmpresas',
            method: "GET",
            query: data.filters,
            pagination: data.pagination,
        } as IApiEndpoint<IEmpresa[]>
    },
    ['get-empresa']: (data: { id: number }) => {
        return {
            url: `/api/Empresas/GetEmpresa/${data.id}`,
            method: "GET",
        } as IApiEndpoint<IEmpresa>
    },
    ['create-empresa']: (data: ICreateEmpresaDto) => {
        return {
            url: '/api/Empresas/Create',
            method: "POST",
            body: data,
        } as IApiEndpoint<IEmpresa>
    },
    ['import-empresas']: (data: ICreateEmpresaDto[]) => {
        return {
            url: '/api/Empresas/Import',
            method: "POST",
            body: data,
        } as IApiEndpoint<IEmpresa[]>
    }
} as const

export const _empresa_sitemap = {
    ['empresas']: {
        url: 'empresas',
        descricao: 'Empresas',
        nome: 'Empresas',
        permissao: ['AbrirAplicacao'],
        fullUrl: '/empresas/menu',
        children: {
            ['menu']: {
                url: 'menu',
                fullUrl: '~',
                descricao: 'Menu de empresas',
                nome: 'Menu de empresas',
                permissao: ['AbrirAplicacao'],
            },
            ['detalhes']: {
                url: 'detalhes',
                descricao: 'Detalhes da empresa',
                nome: 'Detalhes da empresa',
                fullUrl: '/empresas/detalhes',
                permissao: ['AbrirAplicacao'],
            }
        }
    } as IMapDefinition
} as const

export default _empresa_endpoints